module.exports = __webpack_public_path__ + "static/media/vibino-feature-speech bubble-pic1.fa50a4de.jpg";